import {
  createManufacturer,
  deleteManufacturer,
  editManufacturer,
  listOfManufacturer,
} from "Api/ManuFacturer";
import BaseButton from "Components/Base/BaseButton";
import BaseInput from "Components/Base/BaseInput";
import BaseModal from "Components/Base/BaseModal";
import DeleteModal from "Components/Base/DeleteModal";
import Pagination from "Components/Common/Pagination";
import withRouter from "Components/Common/withRouter";
import {
  checkStatusCodeSuccess,
  Loading,
  notFound,
} from "Components/constants/Common";
import { renderSkeletons } from "Components/constants/layout";
import {
  addMakeLabel,
  editMakeLabel,
  makeLabel,
  makeName,
} from "Components/constants/ManuFacturer";
import {
  cancelLabel,
  DeleteLabel,
  editLabel,
  NewLabel,
  submitLabel,
  updateLabel,
} from "Components/constants/Role";
import {
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import * as Yup from "yup";

const ManuFacturer = (props: any) => {
  document.title = makeLabel;

  const [loader, setLoader] = useState<boolean>(false);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [manuFacturers, setManuFacturer] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selectedManuFacturerId, setSelectedManuFacturerId] = useState<
    number | null
  >(null);
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [modalLoader, setModalLoader] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState(12);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [onValueSearch, setOnValueSearch] = useState<string>("");
  const [manuFacturersData, setManuFacturersGroupData] = useState<string>("");

  const manuFacturerModal = () => {
    setIsModalOpen(true);
    setManuFacturersGroupData("");
  };

  const closeModal = () => {
    setIsModalOpen(false);
    formik.resetForm();
    setSelectedManuFacturerId(null);
    setEditMode(false);
    setManuFacturersGroupData("");
  };

  const fetchManuFacturer = async () => {
    const payload = {
      pageSize,
      page: currentPage,
      search: onValueSearch,
    };
    setLoader(true);
    listOfManufacturer(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setManuFacturer(res?.data?.manufacturers || []);
          setTotalRecords(res?.data?.totalItems || 0);
          setTotalPages(res?.data?.totalPages);
          setCurrentPage(res?.data?.currentPage);
          toast.success(res?.message);
        } else {
          setManuFacturer([]);
        }
      })
      .catch(() => {
        setManuFacturer([]);
      })
      .finally(() => setLoader(false));
  };

  useEffect(() => {
    fetchManuFacturer();
  }, [currentPage, pageSize, onValueSearch]);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: manuFacturersData ? manuFacturersData : null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required(validationMessages.required(makeName)),
    }),
    onSubmit: async (values) => {
      setSubmitLoader(true);
      const payload = {
        name: values.name,
      };

      if (selectedManuFacturerId) {
        editManufacturer(selectedManuFacturerId, payload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.statusCode)) {
              toast.success(res?.message);
              fetchManuFacturer();
              closeModal();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((error) => {
            toast.error(error?.response?.data?.message || error?.message);
          })
          .finally(() => setSubmitLoader(false));
      } else {
        createManufacturer(payload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.statusCode)) {
              toast.success(res?.message);
              fetchManuFacturer();
              closeModal();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((error) => {
            toast.error(error?.response?.data?.message || error?.message);
            setSubmitLoader(false);
          })
          .finally(() => setSubmitLoader(false));
      }
    },
  });

  const openDeleteModal = (id: number) => {
    setSelectedManuFacturerId(id);
    setDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
    setSelectedManuFacturerId(null);
  };

  const handleDeleteMaterial = () => {
    if (selectedManuFacturerId !== null) {
      setBtnLoader(true);
      deleteManufacturer(selectedManuFacturerId)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            fetchManuFacturer();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => {
          setBtnLoader(false);
          closeDeleteModal();
        });
    }
  };

  const viewManuFacturerData = (id: number) => {
    const payload = {
      id,
    };

    manuFacturerModal();
    setModalLoader(true);
    listOfManufacturer(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setManuFacturersGroupData(res?.data?.manufacturers[0]?.name);
          setSelectedManuFacturerId(id);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => setModalLoader(false));
  };

  const openEditModal = async (id: number) => {
    setEditMode(true);
    viewManuFacturerData(id);
    setModalLoader(true);
  };

  return (
    <div className="page-content">
      <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
        <span className="fs-4 d-flex gap-4">{makeLabel} </span>
        <div className="d-flex align-items-center gap-2">
          <BaseButton
            className="btn btn-success"
            onClick={manuFacturerModal}
            children={
              <>
                <i className="mdi mdi-plus" /> {NewLabel}
              </>
            }
          />
        </div>
      </div>

      <Pagination
        pageSizeValue={pageSize}
        totalPages={totalPages}
        totalRecords={totalRecords}
        setOnValueSearchBar={setOnValueSearch}
        data={manuFacturers}
        setPageSizeValue={setPageSize}
        setCurrentPageValue={setCurrentPage}
        children={
          <>
            {" "}
            {loader ? (
              <div className="d-flex row mt-3">{renderSkeletons(pageSize)}</div>
            ) : (
              <div className="d-flex row mt-3">
                {manuFacturers?.length > 0 ? (
                  manuFacturers?.map((manuFacturer, index) => (
                    <div key={index} className="col-lg-3 col-md-4 col-12">
                      <div className="card card-animate ribbon-box overflow-hidden">
                        <div className="card-body py-4 text-center">
                          <div className="ribbon ribbon-shape shadow-none ribbon-info">
                            {makeLabel}
                          </div>
                          <div
                            className={
                              manuFacturer.name.length > 12
                                ? `d-flex align-items-end justify-content-between mt-4 tooltip-container`
                                : `d-flex align-items-end justify-content-between mt-4`
                            }
                          >
                            <span className="material-name">
                              {manuFacturer.name}
                            </span>
                            <div className="d-flex align-items-end text-truncate">
                              <h4 className="fs-22 fw-semibold ff-secondary mb-0 pb-1 text-wrap ">
                                {manuFacturer.name.length > 12 ? (
                                  <span>
                                    {manuFacturer.name.substring(0, 12)}...
                                  </span>
                                ) : (
                                  manuFacturer.name
                                )}
                              </h4>
                            </div>
                          </div>
                          <div className="text-center d-flex justify-content-end mt-2 gap-2">
                            <BaseButton
                              className="btn btn-light py-0 px-2"
                              onClick={() => openEditModal(manuFacturer.id)}
                            >
                              <span className="tooltip-container">
                                <i className="mdi mdi-pencil-outline fs-4 text-dark cursor-pointer"></i>
                                <span className="tooltip-text">
                                  {editLabel}
                                </span>
                              </span>
                            </BaseButton>
                            {/* delete future purpose */}
                            {/* <BaseButton
                              className="btn btn-light py-0 px-2"
                              onClick={() => openDeleteModal(manuFacturer.id)}
                            >
                              <span className="tooltip-container">
                                <i className="mdi mdi-delete-outline fs-4 text-danger cursor-pointer"></i>
                                <span className="tooltip-text">
                                  {DeleteLabel}
                                </span>
                              </span>
                            </BaseButton> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="card py-5">
                    <div className="py-4 text-center">
                      <div>
                        <span className="fs-1 text-success">
                          <RiSearchLine />
                        </span>
                      </div>
                      <div className="mt-4">
                        <h5>{notFound.dataNotFound}</h5>
                        <p className="text-muted">
                          {notFound.thereIsNoDataFound}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        }
      />

      <BaseModal
        open={isModalOpen}
        toggle={closeModal}
        title={editMode ? editMakeLabel : addMakeLabel}
        submit={formik.handleSubmit}
        closeLabel={cancelLabel}
        submitLabel={editMode ? updateLabel : submitLabel}
        closeLabelColor="danger"
        submitLabelColor="success"
        loader={submitLoader}
        isSubmitDisabled={!formik.dirty}
      >
        {modalLoader ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner>{Loading}</Spinner>
          </div>
        ) : (
          <div className="form-group">
            <BaseInput
              type="text"
              label={makeName}
              placeholder={InputPlaceHolder(makeName)}
              name="name"
              className="form-control"
              value={formik.values.name}
              onChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              touched={formik.touched.name}
              error={formik.errors.name}
              required
            />
          </div>
        )}
      </BaseModal>

      <DeleteModal
        show={deleteModal}
        onCloseClick={closeDeleteModal}
        onDeleteClick={handleDeleteMaterial}
        btnLoader={btnLoader}
      />
    </div>
  );
};

export default withRouter(ManuFacturer);
